// Moduly, které se po startu stahují na pozadí zvlášť (rozpočet hlavního balíku — offline fronta, poloha nabídek
// výběru). Když se stažení nepovede (po nasazení nové verze starý chunk zmizel, nebo zrovna není signál), zkusí se
// znovu po chvíli a po návratu signálu — jako Zkusit znovu u `lina()` (kontrola #761, N1). Bez stránky s chybou: jde
// o službu na pozadí, obrazovka funguje dál.

/** Kolikrát se modul zkusí stáhnout, než se čeká jen na návrat signálu. */
export const POKUSU_NA_POZADI = 3;
const PRODLEVA_MS = 2000;

/**
 * Stáhne modul na pozadí s opakováním; `naNacteni` zavolá jen jednou a jen dokud se nezavolá vrácené zrušení.
 * `cekat` jde v testu nahradit (bez skutečného čekání).
 */
export function nactiNaPozadi<M>(
  nacti: () => Promise<M>,
  naNacteni: (modul: M) => void,
  cekat: (ms: number) => Promise<void> = (ms) => new Promise((r) => setTimeout(r, ms)),
): () => void {
  let zruseno = false;
  const zkusit = async (pokus: number): Promise<void> => {
    try {
      const modul = await nacti();
      if (!zruseno) naNacteni(modul);
    } catch (chyba) {
      if (zruseno) return;
      if (pokus < POKUSU_NA_POZADI) {
        await cekat(PRODLEVA_MS * pokus);
        if (!zruseno) await zkusit(pokus + 1);
        return;
      }
      console.warn('Část aplikace se na pozadí nestáhla — zkusí se po návratu signálu.', chyba);
      if (typeof window !== 'undefined') {
        window.addEventListener('online', () => void (zruseno ? undefined : zkusit(1)), {
          once: true,
        });
      }
    }
  };
  void zkusit(1);
  return () => {
    zruseno = true;
  };
}
